import "./Electricity_recharge_plan_card_holder.css";

function Electricity_recharge_plan_card_holder() {

    return (
        <section className='Mobile_recharge_plan_card_holder DTH_recharge_plan_card_holder Electricity_recharge_plan_card_holder'>
            <div className="plan_card_holder">
                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Customer Name:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>Pratiksha P.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Due Date:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>01 Jan 2025</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Bill Amount:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>₹ 499.0</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Electricity_recharge_plan_card_holder;
